import { Box, GridItem, Icon, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";
import type { DropzoneState } from "react-dropzone";
import { useStaticDataAtomValue } from "../../staticDataAtom";

interface Props extends Pick<DropzoneState, "getInputProps"> {
    open(): void;
}

export const AddPhotoController: FunctionComponent<Props> = ({ getInputProps, open }) => {
    const {
        cmsData: {
            photo: { addPhotos },
        },
    } = useStaticDataAtomValue();

    return (
        <GridItem sm={6} md={4}>
            <Box
                width="100%"
                aspectRatio="1"
                borderRadius="8"
                p="16"
                borderColor="base.default"
                backgroundColor="base.surface"
                borderStyle="dashed"
                borderWidth="1"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                cursor="pointer"
                data-element-name="add-photos"
                onClick={open}
            >
                <input {...getInputProps()} />
                <Icon size="24" id="fill.symbol.plus" color="product.primary" />
                <Typography variant="body-s-strong" textColor="product.primary" mt="8">
                    {addPhotos}
                </Typography>
            </Box>
        </GridItem>
    );
};
